import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PairingStepFormComponent } from './core/components/pairing-step-form/pairing-step-form.component';
import { AdminComponent } from './core/components/admin/admin.component';
import { HomeComponent } from './core/components/home/home.component';
import { InsightsComponent } from './core/components/insights/insights.component';

const routes: Routes = [
  {
    path: 'login/token',
    component: PairingStepFormComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
  },
  {
    path: 'insights',
    component: InsightsComponent,
  },
  {
    path: 'pairingAsProduct',
    component: PairingStepFormComponent,
  },
  {
    path: 'pairingAsProduct/edit/:id',
    component: PairingStepFormComponent,
  },
  {
    path: 'pairingAsProduct/copy/:id',
    component: PairingStepFormComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
